import { erpAxios } from '..';

const statusOdobren = async (data) => {
  const res = await erpAxios.post(`/statusZahtjeva/odobren`, data);
  return res;
};

export default statusOdobren;
